/**
 * Nutrition / substrate conversion helpers.
 *
 * Single source of truth for the kcal <-> grams conversion of the two
 * energy substrates. Energy is computed and transmitted in kcal/h
 * (fat vs. carbohydrate energy density differs, so kcal is the fair
 * cross-substrate comparison); athletes fuel in grams, so both are shown.
 *
 * @category   Javascript
 * @author     Jakob Ohlsen <jakob.ohlsen@gmail.com>
 * @copyright  2025 Jakob Ohlsen
 */
/** Energy yield of carbohydrate oxidation [kcal per gram] (glycogen ≈ 4.1). */
const KCAL_PER_G_CARB = 4.1;
/** Energy yield of fat oxidation [kcal per gram] (in-vivo ≈ 9.4–9.5). */
const KCAL_PER_G_FAT = 9.4;
/** Convert an energy amount (kcal) of a substrate to its mass in grams. */
export function kcalToG(kcal, substrate) {
    return kcal / (substrate === 'carb' ? KCAL_PER_G_CARB : KCAL_PER_G_FAT);
}
